// src/talent/components/cropUtils.js
export default async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const radians = (rotation * Math.PI) / 180;

  // Calculate bounding box of rotated image
  const { width: bboxWidth, height: bboxHeight } = getRotatedSize(
    image.width,
    image.height,
    rotation
  );

  // Canvas size = EXACT crop size (this preserves portrait/landscape)
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.save();

  // Move crop origin
  ctx.translate(-pixelCrop.x, -pixelCrop.y);

  // Move image center
  ctx.translate(bboxWidth / 2, bboxHeight / 2);
  ctx.rotate(radians);
  ctx.translate(-image.width / 2, -image.height / 2);

  ctx.drawImage(image, 0, 0);

  ctx.restore();

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        resolve({ blob });
      },
      "image/jpeg",
      0.95
    );
  });
}

// ---------- helpers ----------

function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

function getRotatedSize(width, height, rotation) {
  const radians = (rotation * Math.PI) / 180;
  return {
    width:
      Math.abs(Math.cos(radians) * width) +
      Math.abs(Math.sin(radians) * height),
    height:
      Math.abs(Math.sin(radians) * width) +
      Math.abs(Math.cos(radians) * height),
  };
}
